module.exports = __webpack_public_path__ + "img/top_slider_202512_manavisfesta.05f24916.jpg";